export enum BtnTypeEnum {
    "DISABLED",
    "DEPOSITE",
    "CANCLAIM",
    "CLAIMED",
}

export const BtnTypeMap = new Map<BtnTypeEnum, string>([
    [BtnTypeEnum.DISABLED, "Recompensa Recebida"],
    [BtnTypeEnum.DEPOSITE, "Recarregar"],
    [BtnTypeEnum.CANCLAIM, "Receber Recompensa"],
]);

// 进行中running、待领取pending、已领取received、已过期expired

export enum CashbackStatusEnum {
    "RUNNING" = "running",
    "PENDING" = "pending",
    "RECEIVED" = "received",
    "EXPIRED" = "expired",
}

export const CashbackStatusMap = new Map<CashbackStatusEnum, string>([
    [CashbackStatusEnum.RUNNING, "cashback.goGame"],
    [CashbackStatusEnum.PENDING, "cashback.receiveButton"],
    [CashbackStatusEnum.RECEIVED, "cashback.goGame"],
    [CashbackStatusEnum.EXPIRED, "cashback.goGame"],
]);

export const ClaimActiveErrorMap = new Map<number, string>([
    [1022, "Restrição anormal de conta"],
    [6002, "Nenhum bônus não pode ser reclamado no modo bônus ativado"],
    [6001, "As condições do bônus de esvaziamento não são atendidas"],
]);

export enum FundsHandleType {
    DEPOSITE = 1,
    WITHDRAW = 2,
}
export const FundsHandleTypeMap = new Map<FundsHandleType, Record<string, string>>([
    [
        FundsHandleType.DEPOSITE,
        {
            text: "Depósito",
            descTitle: "Depósito",
        },
    ],
    [
        FundsHandleType.WITHDRAW,
        {
            text: "Sacar",
            descTitle: "Regras de saque",
        },
    ],
]);

export enum ChannelEnum {
    CPF = 1,
    Email = 2,
    Phone = 3,
    CNPJ = 4,
}

export const ChannelEnumMap = new Map<ChannelEnum, Record<string, string>>([
    [
        ChannelEnum.CPF,
        {
            placeholder: "Seu CPF(000.000.000-00)",
            text: "CPF ID",
        },
    ],
    [
        ChannelEnum.Email,
        {
            text: "Email",
            placeholder: "Email",
        },
    ],
    [
        ChannelEnum.Phone,
        {
            text: "Phone",
            placeholder: "11 dígitos",
        },
    ],
    [
        ChannelEnum.CNPJ,
        {
            text: "CNPJ",
            placeholder: "CNPJ(00.000.000.0000-00)",
        },
    ],
]);

export enum GameListTypeEnum {
    PROVIDER = "provider_id",
    TAG = "tag_id",
    DEFAULT = "",
}

export const HeaderImageMap = new Map<number, Record<string, any>>([
    [
        1,
        {
            img: "/user_header/h_1.webp",
        },
    ],
    [
        2,
        {
            img: "/user_header/h_2.webp",
        },
    ],
    [
        3,
        {
            img: "/user_header/h_3.webp",
        },
    ],
    [
        4,
        {
            img: "/user_header/h_4.webp",
        },
    ],
    [
        5,
        {
            img: "/user_header/h_5.webp",
        },
    ],
    [
        6,
        {
            img: "/user_header/h_6.webp",
        },
    ],
    [
        7,
        {
            img: "/user_header/h_7.webp",
        },
    ],
    [
        8,
        {
            img: "/user_header/h_8.webp",
        },
    ],
]);
